import React from 'react';
import { Navbar } from './Navbar';
import { SiteFooter } from './SiteFooter';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="w-full min-h-screen font-heading" style={{
    backgroundColor: '#09090B'
  }} data-id="element-534">
      <Navbar data-id="element-535" />
      <main data-id="element-536">{children}</main>
      <SiteFooter data-id="element-537" />
    </div>;
}